import moment from 'moment';
import { useEffect, useState } from "react";
import { showErrorNotification } from "../../Services/Notifications";
import { Constants } from '../../Utils/Constants';

const startTime = '09:00';
const endTime = '14:43';
function isTimeBetween(startTime, endTime) {
  const currentTime = moment();
  const format = 'HH:mm';
  const startMoment = moment(startTime, format);
  const endMoment = moment(endTime, format);
  return currentTime.isBetween(startMoment, endMoment);
}

let calcFinalRatePaise = (ibr, custMargin, holidayMargin, type, isWorkingTime,ibrCode) => {

  if (isWorkingTime) holidayMargin = 0;
  let digitToShow=2;
  if(Constants.IBRCODES_FIVE_DECIMAL.includes(ibrCode))
    digitToShow=5;
  if (type === 'buy') return (ibr * 1 + custMargin * 1 + holidayMargin * 1).toFixed(digitToShow);
  else return (ibr * 1 - custMargin * 1 - holidayMargin * 1).toFixed(digitToShow);
};

let calcFinalRatePerc = (ibr, custMargin, holidayMargin, type, isWorkingTime,ibrCode) => {
  if (isWorkingTime) holidayMargin = 0;
  ibr = ibr * 1;
  custMargin = custMargin * 1;
  holidayMargin = holidayMargin * 1;
  let digitToShow=2;
  if(Constants.IBRCODES_FIVE_DECIMAL.includes(ibrCode))
    digitToShow=5;
   
  if (type === 'buy') return (ibr + (ibr * custMargin) / 100 + (ibr * holidayMargin) / 100).toFixed(digitToShow);
  else return (ibr - (ibr * custMargin) / 100 - (ibr * holidayMargin) / 100).toFixed(digitToShow);
};

function EditRateTable({currentbranch,index,selectedValue, marginLimit,marginLimitPer, isWorkingTime}){

    const [finalBuyRate,setFinalBuyRate]=useState(0);
    const [finalSellRate,setFinalSellRate]=useState(0);
    const [buyMargin,setBuyMargin]=useState(currentbranch.buy_margin);
    const [holidayBuyMargin,setHolidayBuyMargin]=useState(currentbranch.holiday_buy_margin);
    const [sellMargin,setSellMargin]=useState(currentbranch.sell_margin);
    const [holidaySellMargin,setHolidaySellmargin]=useState(currentbranch.holiday_sell_margin);
   
    useEffect(()=>{
        let final=selectedValue === 'Paise'? 
        calcFinalRatePaise(currentbranch.ask||currentbranch.ibr, currentbranch.buy_margin, currentbranch.holiday_buy_margin, 'buy', isWorkingTime,currentbranch.currency_code): 
        calcFinalRatePerc(currentbranch.ask||currentbranch.ibr, currentbranch.buy_margin, currentbranch.holiday_buy_margin, 'buy', isWorkingTime,currentbranch.currency_code)
       setFinalBuyRate( final)

    },[buyMargin,holidayBuyMargin,selectedValue,currentbranch]);

    useEffect(()=>{
      setBuyMargin(currentbranch.buy_margin)
      setSellMargin(currentbranch.sell_margin)
      setHolidayBuyMargin(currentbranch.holiday_buy_margin)
      setHolidaySellmargin(currentbranch.holiday_sell_margin)

    },[currentbranch])
    
    useEffect(()=>{
        setFinalSellRate( selectedValue === 'Paise'? calcFinalRatePaise(currentbranch.ask||currentbranch.ibr, currentbranch.sell_margin, currentbranch.holiday_sell_margin, 'sell', isWorkingTime,currentbranch.currency_code): calcFinalRatePerc(currentbranch.ask||currentbranch.ibr, currentbranch.sell_margin, currentbranch.holiday_sell_margin, 'sell', isWorkingTime,currentbranch.currency_code)
        )

    },[sellMargin,holidaySellMargin,selectedValue,currentbranch])
    let limitErrorMsg = `Margin upto INR ${marginLimit}/- is allowed only`;

    if(selectedValue!=='Paise')
    limitErrorMsg= `A maximum margin of ${marginLimitPer}% is permitted.`;
    const checkLimit=(val)=>{
      let limit=selectedValue==='Paise'?marginLimit:marginLimitPer;
      if(val<=limit)
      return true;
      else return false;
    }
    return <tr >
    <td>{currentbranch.code ||currentbranch.name ||  currentbranch.currency_code }</td>
    <td>{currentbranch.ask||currentbranch.ibr}</td>
    <td>
      <input
        onChange={(e) => {
          if(checkLimit(e.target.value*1))
          {
          currentbranch.buy_margin = e.target.value ;
          setBuyMargin(currentbranch.buy_margin)
          }else showErrorNotification(limitErrorMsg)
        }}

        className="form-control"
        type="number"
        min={0+""}
        value={buyMargin}
        
      />
    </td>
    <td>
      <input
        onChange={(e) => {

          if(checkLimit(e.target.value*1))
          {
          currentbranch.holiday_buy_margin = e.target.value ;
          setHolidayBuyMargin( currentbranch.holiday_buy_margin)
          }else showErrorNotification(limitErrorMsg)
        }}
        className="form-control"
        type="number"
        min={0+""}
        value={holidayBuyMargin}
      />
    </td>
    <td>{finalBuyRate}
    
    </td>
    <td>
      <input
        onChange={(e) => {
          if(checkLimit(e.target.value*1))
          {
          currentbranch.sell_margin = e.target.value ;
          setSellMargin(currentbranch.sell_margin )
          }else showErrorNotification(limitErrorMsg)
          
        }}
        className="form-control"
        type="number"
        min={0+""}
        value={sellMargin}
      />
    </td>
    <td>
      <input
        onChange={(e) => {
          if(checkLimit(e.target.value*1))
          {
          currentbranch.holiday_sell_margin = e.target.value ;
          setHolidaySellmargin(currentbranch.holiday_sell_margin)
          }else showErrorNotification(limitErrorMsg)

        }}
        className="form-control"
        type="number"
        min={0+""}
        value={holidaySellMargin}
      />
    </td>
    <td>{finalSellRate}
    
    </td>
  </tr> 
}

export default EditRateTable


